import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/more.svg'
import _imports_1 from '@/assets/icons/edit.svg'
import _imports_2 from '@/assets/icons/target.svg'


const _withScopeId = n => (_pushScopeId("data-v-7c2d7ad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center ml-3 mb-4" }
const _hoisted_2 = { class: "ml-1" }
const _hoisted_3 = { class: "flex flex-row justify-rigth rounded-full text-rigth" }
const _hoisted_4 = { class: "tooltip" }
const _hoisted_5 = { class: "tooltiptext" }
const _hoisted_6 = { class: "flex flex-row justify-rigth rounded-full text-rigth" }
const _hoisted_7 = {
  key: 0,
  class: "text-green-500"
}
const _hoisted_8 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_9 = { class: "flex flex-row justify-rigth rounded-full text-rigth" }
const _hoisted_10 = { class: "text-sm capitalize" }
const _hoisted_11 = { class: "flex items-center justify-rigth" }
const _hoisted_12 = {
  key: 0,
  class: "text-green-500"
}
const _hoisted_13 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "absolute flex flex-col text-black bg-white right-0 mr-10 mt-4 rounded-2xl shadow hover:shadow-md p-2 w-72 z-50"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Edit")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex flex-row items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_24 = { class: "txt-name text-left ml-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
  })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Details", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_CompanyCard = _resolveComponent("CompanyCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VueTableLite = _resolveComponent("VueTableLite")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_ModalAddCompany = _resolveComponent("ModalAddCompany")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SearchInput, {
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
          class: "bg-white",
          placeholder: "Start typing to search company...",
          onOnSubmit: _ctx.searchFilter
        }, null, 8, ["modelValue", "onOnSubmit"])
      ]),
      _createVNode(_component_VueTableLite, {
        "is-loading": _ctx.table.isLoading,
        columns: _ctx.table.columns,
        rows: _ctx.table.rows,
        total: _ctx.table.totalRecordCount,
        sortable: _ctx.table.sortable,
        "is-slot-mode": true,
        messages: _ctx.table.messages,
        "is-hide-paging": true,
        onRowClicked: _ctx.rowClicked
      }, {
        name: _withCtx((data) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CompanyCard, {
              companyName: data.value.name
            }, null, 8, ["companyName"])
          ])
        ]),
        country: _withCtx((data) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(data.value.company_country.short_code) + " ", 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(data.value.company_country.name), 1)
            ])
          ])
        ]),
        is_active_company: _withCtx((data) => [
          _createElementVNode("div", _hoisted_6, [
            (data.value.is_active)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Active"))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, "Inactive"))
          ])
        ]),
        roles: _withCtx((data) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(data.value?.company_products?.join(", ")), 1)
          ])
        ]),
        is_active: _withCtx((data) => [
          _createElementVNode("div", _hoisted_11, [
            (data.value.owner?.status === 'active')
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Active"))
              : _createCommentVNode("", true),
            (data.value.owner?.status === 'deactivated')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Deactivated"))
              : _createCommentVNode("", true),
            (data.value.owner?.status === 'inactive')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn-text",
                  onClick: _withModifiers(($event: any) => (_ctx.resendInvitation(data.value.id)), ["stop"])
                }, " Resend invitation ", 8, _hoisted_14))
              : _createCommentVNode("", true)
          ])
        ]),
        menu: _withCtx((data) => [
          _createElementVNode("button", {
            class: "px-2",
            onClick: _withModifiers(($event: any) => (_ctx.openDropDown(data.value)), ["stop"])
          }, _hoisted_17, 8, _hoisted_15),
          (data.value.id === _ctx.currentDropdown)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: "hover:bg-background p-4 rounded",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
              _ctx.openModal = !_ctx.openModal;
              _ctx.closeMenu();
            }, ["stop"]))
                }, _hoisted_20),
                _createElementVNode("button", {
                  class: "hover:bg-background p-4 rounded",
                  onClick: _withModifiers(($event: any) => {
              _ctx.deactivateClient(data.value);
              _ctx.closeMenu();
            }, ["stop"])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("span", _hoisted_24, _toDisplayString(data.value.is_active ? "Deactivate client" : "Activate client"), 1)
                  ])
                ], 8, _hoisted_21),
                _createVNode(_component_router_link, {
                  class: "hover:bg-background p-4 rounded flex flex-row items-center",
                  to: `/client-detail/${data.value.id}`
                }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _hoisted_26
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])), [
                [_directive_click_away, _ctx.closeMenu]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onRowClicked"]),
      _createVNode(_component_Paginator, {
        modelValue: _ctx.page,
        page: _ctx.page,
        pages: _ctx.pagination.total_pages,
        "range-size": 1,
        "onUpdate:modelValue": _ctx.updateHandler,
        total: _ctx.pagination.total_count,
        from: _ctx.pagination.from,
        to: _ctx.pagination.to
      }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
    ]),
    (_ctx.openModal)
      ? (_openBlock(), _createBlock(_component_ModalAddCompany, {
          key: 0,
          openModal: _ctx.openModal,
          "onUpdate:openModal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openModal) = $event)),
          client: _ctx.client
        }, null, 8, ["openModal", "client"]))
      : _createCommentVNode("", true)
  ], 64))
}